import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=67ac2bea&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=67ac2bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac2bea",
  null
  
)

export default component.exports